if (!window.urlParamEffectsInitialized) {
    window.urlParamEffectsInitialized = true;

    const URL_PARAM_HANDLERS = {
        otp: (value) => {
            if (value === 'true') {
                document.querySelectorAll('[data-plp-add-to-cart-form] input[data-selling-plan-input]').forEach(input => input.remove());
            }
        }
    };

    function applyUrlParamEffects() {
        const urlParams = new URLSearchParams(window.location.search);
        Object.entries(URL_PARAM_HANDLERS).forEach(([param, handler]) => {
            const value = urlParams.get(param);
            if (value !== null) handler(value);
        });
    }

    document.addEventListener('DOMContentLoaded', applyUrlParamEffects);
}